import { render, staticRenderFns } from "./NewPaymentsPayoneerTable.vue?vue&type=template&id=49ca2497&scoped=true"
import script from "./NewPaymentsPayoneerTable.vue?vue&type=script&lang=js"
export * from "./NewPaymentsPayoneerTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ca2497",
  null
  
)

export default component.exports